export enum HeadingVariant {
  FINANCING_CONSULTING,
  FORM_ON_MAIN_FINANCING_PAGE,
  FORM_ON_MAIN_FINANCING_PAGE_MOBILE,
}
